import React, {
    ButtonHTMLAttributes,
    FC,
    HTMLAttributeAnchorTarget,
    PropsWithChildren,
} from 'react';
import classNames from 'classnames';
import { Link } from '@inertiajs/react';

import { DEFAULT_STYLE_VARIANT, StyleVariant } from '@/types/style.type';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
    PropsWithChildren<{
        elementType?: 'button' | 'a' | 'link';
        variant: StyleVariant;
        className?: string;
        disabled?: boolean;
        target?: HTMLAttributeAnchorTarget;
        href?: string;
    }>;

export const Button: React.FC<ButtonProps> = ({
    // TODO: Handle element type
    elementType,
    variant,
    children,
    className,
    disabled,
    ...props
}) => {
    const ElementType: string | FC<any> =
        elementType === 'link'
            ? Link
            : (elementType ??
              ('button' as keyof React.JSX.IntrinsicElements &
                  PropsWithChildren));

    const baseStyles =
        '!leading-none py-1 px-2 transition ease-in-out duration-200 border border-transparent focus:outline-none ring-offset-2 focus:ring-2 rounded-md font-sans text-body-text text-white bg-gradient-to-b';

    const variantStyles = classNames({
        'from-ocean-700 to-ocean-800 hover:from-ocean-400 hover:to-ocean-500 focus:ring-brand-ocean':
            variant === 'primary',
        'from-blue-600 to-brand-blue hover:from-blue-400 hover:to-blue-700 focus:ring-brand-blue':
            variant === 'secondary',
        'from-teal-400 to-teal-600 hover:from-teal-200 hover:to-teal-500 focus:ring-brand-teal':
            variant === 'success',
        'from-brand-red to-orange-700 hover:from-orange-400 hover:to-orange-500 focus:ring-brand-red':
            variant === 'danger',
        'bg-neutral-mid !duration-75 border !border-gray-50 focus:ring-gray-50 !text-brand-ocean ring-offset-neutral-light hover:!bg-neutral-mid/30':
            variant === DEFAULT_STYLE_VARIANT,
    });

    return (
        // @ts-ignore
        <ElementType
            {...props}
            disabled={disabled}
            className={
                disabled
                    ? `${baseStyles} from-gray-400 to-gray-60 ${className}`
                    : `${baseStyles} ${variantStyles} ${className}`
            }>
            {children}
        </ElementType>
    );
};
